import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-75f8e310"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "padding-16 articles"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "hot-articles-introduce"
};
const _hoisted_4 = {
  class: "hot-articles-title"
};
const _hoisted_5 = {
  style: {
    "color": "#888"
  }
};
import ModuleCard from "@/views/college/components/ModuleCard.vue";
import { useRouter } from "vue-router";
export default /*#__PURE__*/_defineComponent({
  __name: 'RecommendAbout',
  props: {
    list: {
      default: []
    }
  },
  setup(__props) {
    const props = __props;
    const router = useRouter();
    //跳转详情
    const toDetail = val => {
      router.push({
        name: 'zixunDetail',
        params: {
          id: val.id
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      return _openBlock(), _createBlock(ModuleCard, {
        title: "相关推荐"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, item => {
          return _openBlock(), _createElementBlock("div", {
            key: item,
            class: "hot-articles-card",
            onClick: $event => toDetail(item)
          }, [_createVNode(_component_el_image, {
            src: item.coverId,
            fit: "cover",
            class: "hot-articles-img"
          }, null, 8, ["src"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_5, _toDisplayString(item.publishTime), 1)])], 8, _hoisted_2);
        }), 128))])]),
        _: 1
      });
    };
  }
});